import { createTheme } from "@mui/material";
export const AppTheme = createTheme({
  palette: {
    primary: {
      main: "#032B44", // Deep navy (trust, authority)
      light: "#0A4369", // Lighter navy variant
      dark: "#021829", // Darker navy variant
    },
    secondary: {
      main: "#4CAF50", // Safety green (positive actions)
      light: "#81C784",
      dark: "#388E3C",
    },
    error: {
      main: "#D32F2F", // Alert red
    },
    warning: {
      main: "#ED6C02", // Warning orange
    },
    info: {
      main: "#0288D1", // Informational blue
    },
    success: {
      main: "#2E7D32", // Success green
    },
    background: {
      default: "#F8F9FA", // Light neutral background
      paper: "#FFFFFF", // White container background
    },
    text: {
      primary: "#212121", // High contrast text
      secondary: "#455A64",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#032B44",
          color: "#FFFFFF",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #E0E0E0",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          fontWeight: 600,
          textTransform: "none",
          borderRadius: 8,
        },
        containedSecondary: {
          fontWeight: 600,
          textTransform: "none",
          borderRadius: 8,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: "#E8F5E9", // Light success background
        },
        standardError: {
          backgroundColor: "#FFEBEE", // Light error background
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Inter"',
      "system-ui",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem",
    },
    button: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8, // Consistent rounded corners
  },
});
